import(/* webpackMode: "eager" */ "C:\\Users\\wonde\\Downloads\\stellarscholar (9)\\stellarscholar\\src\\app\\page.tsx");
